import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccesibility = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m3.75 6.75 6.174 1.976a.25.25 0 0 0 .152 0L16.25 6.75M10 12V9m0 3-4.25 6.25M10 12l4.25 6.25M12.25 4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgAccesibility);
export { ForwardRef as ReactComponent };
